module.exports = __webpack_public_path__ + "img/411fc29.svg";